export default __webpack_public_path__ + "static/media/circle_edit.91cfdf35.svg";